module.exports = __webpack_public_path__ + "static/media/upchange.d755ad7e.svg";